import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Shell from "./components/Shell";
import {
  LoginPage, DashboardPage, EntitiesPage, InstrumentsPage, CompliancePage,
  ResolutionsPage, FundingPage, ApplicationsPage, InsuranceLoansPage,
  MeetingsPage, StudioPage, StudioEditor, AcademyPage, CoursePage, LessonPage,
  MapsPage, MyRootPage, StructurePage, ConnectPage, BackupPage, IntegrityPage, UsersPage
} from "./Pages";
import {
  PersonalDashboardPage, ProfilePage, CouncilPage, RatesRoomPage,
  GrantsPage, EntityLookupPage, RegulatoryPage, HolidaysPage, AgenciesPage
} from "./PagesExtra";
import { PolicyBankPage, FundingRadarPage, MarketDataPage } from "./PagesIBC";
import { LibraryPage, TaxResourcesPage } from "./PagesLibrary";
import { ApexStructurePage, RegistersPage } from "./PagesApex";
import { BeneficiaryPage, EstateDraftingPage } from "./PagesEstate";
import { TaxClassificationPage } from "./PagesTax";
import { DraftingStudioPage, DraftingSessionPage, ClauseLibraryPage, BookkeepingLibraryPage, CreditorRemedyPage } from "./PagesDrafting";
import { EstateValuePage, EntityHubPage, ComplianceCalendarPage, TimeCapsulePage, EstateAssistantPage, SignatureRequestsPage, NextGenTrainingPage } from "./PagesPhase3";
import { PeopleDirectoryPage, DigitalAssetsPage, PhysicalAssetsPage, LegacyMessagesPage, HealthcareDirectivesPage, FinalWishesPage, EmergencyContactsPage, VaultPage, RemindersPage, ActivationPage, AuditTrailPage, NotificationsPage, FamilyOfficePage, FamilyGovernancePage, BusinessSuccessionPage } from "./PagesLegacy";
import { MediaLibraryPage } from "./PagesMedia";
import { SafetyProvenancePage, DisputesPage } from "./PagesMP4";
import { AcademyHomePage, TranscriptPage, VerifyTranscriptPage, BadgesPage, AcademicRolesPage, PracticumInboxPage, IntegrityCasesPage, QaCenterPage, TeachingGeneratorPage } from "./PagesAcademyLMS";
import { SubAgentConsolePage, ReleaseGatePage, DependencyMapPage } from "./PagesSubAgents";
import { ContinuityPage, InterfaceModePage } from "./PagesDR";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/academy/verify" element={<VerifyTranscriptPage />} />
        <Route element={<Shell />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/me" element={<PersonalDashboardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/council" element={<CouncilPage />} />
          <Route path="/rates" element={<RatesRoomPage />} />
          <Route path="/grants-explorer" element={<GrantsPage />} />
          <Route path="/lookup" element={<EntityLookupPage />} />
          <Route path="/agencies" element={<AgenciesPage />} />
          <Route path="/regulatory" element={<RegulatoryPage />} />
          <Route path="/holidays" element={<HolidaysPage />} />
          <Route path="/entities" element={<EntitiesPage />} />
          <Route path="/instruments" element={<InstrumentsPage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/resolutions" element={<ResolutionsPage />} />
          <Route path="/funding" element={<FundingPage />} />
          <Route path="/funding-radar" element={<FundingRadarPage />} />
          <Route path="/policy-bank" element={<PolicyBankPage />} />
          <Route path="/market-data" element={<MarketDataPage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/apex-structure" element={<ApexStructurePage />} />
          <Route path="/registers" element={<RegistersPage />} />
          <Route path="/beneficiaries" element={<BeneficiaryPage />} />
          <Route path="/estate-drafting" element={<EstateDraftingPage />} />
          <Route path="/tax-classification" element={<TaxClassificationPage />} />
          <Route path="/tax-resources" element={<TaxResourcesPage />} />
          <Route path="/people" element={<PeopleDirectoryPage />} />
          <Route path="/vault" element={<VaultPage />} />
          <Route path="/media" element={<MediaLibraryPage />} />
          <Route path="/digital-assets" element={<DigitalAssetsPage />} />
          <Route path="/physical-assets" element={<PhysicalAssetsPage />} />
          <Route path="/legacy-messages" element={<LegacyMessagesPage />} />
          <Route path="/healthcare-directives" element={<HealthcareDirectivesPage />} />
          <Route path="/final-wishes" element={<FinalWishesPage />} />
          <Route path="/emergency-contacts" element={<EmergencyContactsPage />} />
          <Route path="/reminders" element={<RemindersPage />} />
          <Route path="/activation" element={<ActivationPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/audit" element={<AuditTrailPage />} />
          <Route path="/safety" element={<SafetyProvenancePage />} />
          <Route path="/disputes" element={<DisputesPage />} />
          <Route path="/sub-agents" element={<SubAgentConsolePage />} />
          <Route path="/release-gate" element={<ReleaseGatePage />} />
          <Route path="/dependency-map" element={<DependencyMapPage />} />
          <Route path="/continuity" element={<ContinuityPage />} />
          <Route path="/interface-mode" element={<InterfaceModePage />} />
          <Route path="/applications" element={<ApplicationsPage />} />
          <Route path="/insurance-loans" element={<InsuranceLoansPage />} />
          <Route path="/meetings" element={<MeetingsPage />} />
          <Route path="/studio" element={<StudioPage />} />
          <Route path="/drafting" element={<DraftingStudioPage />} />
          <Route path="/drafting/:sid" element={<DraftingSessionPage />} />
          <Route path="/clause-library" element={<ClauseLibraryPage />} />
          <Route path="/bookkeeping" element={<BookkeepingLibraryPage />} />
          <Route path="/creditor-remedies" element={<CreditorRemedyPage />} />
          <Route path="/family-office" element={<FamilyOfficePage />} />
          <Route path="/estate-value" element={<EstateValuePage />} />
          <Route path="/entity-hub" element={<EntityHubPage />} />
          <Route path="/compliance-calendar" element={<ComplianceCalendarPage />} />
          <Route path="/time-capsule" element={<TimeCapsulePage />} />
          <Route path="/estate-assistant" element={<EstateAssistantPage />} />
          <Route path="/signatures" element={<SignatureRequestsPage />} />
          <Route path="/family-governance" element={<FamilyGovernancePage />} />
          <Route path="/business-succession" element={<BusinessSuccessionPage />} />
          <Route path="/next-gen-training" element={<NextGenTrainingPage />} />
          <Route path="/studio/:id" element={<StudioEditor />} />
          <Route path="/academy" element={<AcademyPage />} />
          <Route path="/academy/home" element={<AcademyHomePage />} />
          <Route path="/academy/transcript" element={<TranscriptPage />} />
          <Route path="/academy/verify" element={<VerifyTranscriptPage />} />
          <Route path="/academy/badges" element={<BadgesPage />} />
          <Route path="/academy/roles" element={<AcademicRolesPage />} />
          <Route path="/academy/practicum-inbox" element={<PracticumInboxPage />} />
          <Route path="/academy/integrity" element={<IntegrityCasesPage />} />
          <Route path="/academy/qa" element={<QaCenterPage />} />
          <Route path="/academy/teaching" element={<TeachingGeneratorPage />} />
          <Route path="/academy/:id" element={<CoursePage />} />
          <Route path="/academy/lesson/:id" element={<LessonPage />} />
          <Route path="/maps" element={<MapsPage />} />
          <Route path="/my-root" element={<MyRootPage />} />
          <Route path="/structure" element={<StructurePage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/backup" element={<BackupPage />} />
          <Route path="/integrity" element={<IntegrityPage />} />
          <Route path="/users" element={<UsersPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
